import React from "react"
import { navigate } from "gatsby-link"

import pageTitleStyles from './page_titles.module.scss'
import tabbedStyles from './games_tabbed.module.scss'

import EpaTiers from "./epa_tiers"
import XbyY from "./x_by_y"
import EpaTiersTeam from "./epa_tiers_by_team"
import TeamBoxSort from "./team_box_sort"
import TeamTendencies from "./team_tendency_box"
import WinTotals from "./Sub Pages/Win Totals/team_win_totals"
import StrengthOfSchedule from "./Sub Pages/Strength of Schedule/strength_of_schedule"



const TeamsTabbed = ({activeIndex}) => {

    const tabs = [
        {
            'index' : 0,
            'id' : 'power_ranks',
            'name' : 'Power Rankings',
            'component' : <TeamBoxSort />,
            'route' : '/nfl-power-ratings/',
        }, 
        {
            'index' : 1,
            'id' : 'team_tendencies',
            'name' : 'Team Tendencies',
            'component' : <TeamTendencies />,
            'route' : '/nfl-power-ratings/nfl-team-tendencies/',
        }, 
        {
            'index' : 2,
            'id' : 'epa_tiers',
            'name' : 'EPA Tiers',
            'component' : <EpaTiers />,
            'route' : '/nfl-power-ratings/nfl-epa-tiers/',
        }, 
        {
            'index' : 3,
            'id' : 'epa_tiers_team',
            'name' : 'EPA Tiers by Team',
            'component' : <EpaTiersTeam />,
            'route' : '/nfl-power-ratings/nfl-epa-tiers-by-team/',
        }, 
        {
            'index' : 4,
            'id' : 'win_totals',
            'name' : 'Win Totals',
            'component' : <WinTotals />,
            'route' : '/nfl-power-ratings/nfl-win-totals/',
        },
        {
            'index' : 5,
            'id' : 'strength_of_schedule',
            'name' : 'Strength of Schedule',
            'component' : <StrengthOfSchedule />,
            'route' : '/nfl-power-ratings/nfl-strength-of-schedule/',
        }, 
        {
            'index' : 6,
            'id' : 'x_by_y',
            'name' : 'X by Y',
            'component' : <XbyY />,
            'route' : '/nfl-power-ratings/nfl-metric-comparison/',
        }, 
    ]

    const tabToDisplay =  tabs[activeIndex]['component']

    return (
        <div className={pageTitleStyles.page_container}>
            <div className={pageTitleStyles.title_div}>
                <h2 className={pageTitleStyles.title_h2}>Team Rankings and Stats</h2>
                <h3 className={pageTitleStyles.title_h3}>nfelo Power Rankings, Team Tendencies, EPA Tiers, and Grade Comparisons</h3>
            </div>
            <div className={tabbedStyles.tab_container}>
                {tabs.map((item) => {
                    return (
                        <button
                            className={tabbedStyles.tab_button}
                            key={item.id}
                            onClick={()=> {navigate(item.route)}}
                            data-active={activeIndex===item.index ? true : false }
                        >
                            {item.name}
                        </button>
                    )
                })}
            </div>
            {tabToDisplay}
        </div>
    )
}

export default TeamsTabbed